import React, { memo, useCallback } from 'react';
import { getLiteral } from 'utils/getLiteral';
import copyToClipboard from 'utils/copy';
import './styles.scss';

const ValueBox = memo(({ value, buttonLiteral, onCopy }) => {
    let buttonClasses = ['button'];

    if (!value) {
        buttonClasses.push('button-disabled');
    }

    const onClick = useCallback(() => {
        copyToClipboard(value);
        onCopy?.();
    }, [onCopy, value]);

    return (
        <div className="valuebox">
            <div className="value text-ellipsis">{value}</div>
            <div className={buttonClasses.join(' ')} onClick={onClick}>
                <span>{getLiteral(buttonLiteral)}</span>
            </div>
        </div>
    );
});

export default ValueBox;
